import React, { Component } from 'react';
import "./index.less";
import { getPlatformName, requests, messageShow, getLoginShopInfo, matchSupplierProduct, systemConfig } from '../../utils/http.js';
import ShowModal from '../showModal/index.jsx';
import MyLoading from '../showLoading/showLoading.jsx';
import { withRouter } from 'react-router-dom';
import { getLastSyncTime,GetPayUrlRequest,GetPayResultRequest,CancelPurchaseOrderRequest, getZhuKeReqTask,SyncOrderByIdsRequest,loadSupplierProduct,saveOrderSkuMapping,OrderTagsListRequest,SaveOrderSkuMappingV2Request,RelateTemporaryProductV2Requset} from '../../utils/api';
import { huoyuanLink } from '../../utils/index.js';


class SingleCheckSkuModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      loadingTitle: '',
      isShowDailog: props.showModal,
      title:props.title || '确定',
      saleProps:[
        {
          label:'颜色',
          propsValues:[ { label:'黄色', value:'黄色',checked:false}]
        }
      ],
      mappingCount:1,
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。

  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    const productId = props.selectSupplierProductId
    const sourcePlatform = props.selectSupplierProductSourcePlatform
    const product = props.selectProduct
    const mappingCount = props.mappingCount || 1;
    const selectedSkuId = props.selectedSkuId;

    if (props.showModal != this.state.isShowDailog && props.showModal == true) {
      if(product){
        this.initProduct(product,selectedSkuId)
      }
      else if (productId) {
        this.loadSupplierProduct(productId, sourcePlatform,selectedSkuId)
      }
    }
    this.setState({
      isShowDailog: props.showModal,
      selectSupplierProductId:productId,
      selectSupplierProductPlatform:sourcePlatform,
      selectProduct:product,
      mappingCount:mappingCount
    })
  }
  closeShowModal = () => {
    this.setState({ isShowDailog: false, supplierProductList: [], isSupplierProductList: false });
    this.props.closeShowModal();
  }
  loadSupplierProduct =async (productId,sourcePlatform,selectedSkuId)=>{
    const data = { }
    data.SupplierProductId = productId
    data.SourcePlatform = sourcePlatform
    this.setState({ isLoading: true })
    const res = await loadSupplierProduct(data);
    this.setState({ isLoading: false })
    if(!res.Success)
    {
      messageShow(res.Message,'error')
      return
    }
    var supplierProduct = res.Data.AlibabaProduct;
    this.initProduct(supplierProduct,selectedSkuId)
    this.setState({})
  }
  initProduct = (product,selectedSkuId)=>{
    const colors = []
    const sizes = []
    for (let i = 0; i < product.Skus.length; i++) {
      var attrArr = JSON.parse(product.Skus[i].Attributes);
      var color = '';
      var size = '';
      for (let n = 0; n < attrArr.length; n++) {
        if (n == 0) {
          color = attrArr[n].AttributeValue;
        } else {
          size = attrArr[n].AttributeValue;
        }
      }
      if(color && !colors.includes(color)){
        colors.push(color)
      }
      if(size && !sizes.includes(size)){
        sizes.push(size)
      }
      product.Skus[i].Color = color
      product.Skus[i].Size = size
    }

    const saleProps = []
    if(colors.length > 0){
      saleProps.push({
        label:'颜色',
        propsValues:colors.map(x => { return { value:x,label:x}})
      })
    }
    if(sizes.length > 0){
      saleProps.push({
        label:'尺码',
        propsValues:sizes.map(x => { return { value:x,label:x}})
      })
    }

    if(selectedSkuId && saleProps.length > 0){
      const currentSelectedSku = product.Skus.find(x => x.SkuId == selectedSkuId);
      if(currentSelectedSku && currentSelectedSku.Color && colors.length > 0){
        for(const propvalue of saleProps[0].propsValues){
          if(propvalue.value == currentSelectedSku.Color){
            propvalue.checked = true;
            break;
          }
        }
      }
      if(currentSelectedSku && currentSelectedSku.Size && sizes.length > 0){
        for(const propvalue of saleProps[1].propsValues){
          if(propvalue.value == currentSelectedSku.Size){
            propvalue.checked = true;
            break;
          }
        }
      }
    }
    
    this.state.saleProps = saleProps;
  }
  selectPropValue = (propValues,propValue)=>{
    const previousChecked = propValues.find(x => x.checked == true);
    propValues.forEach(x => { x.checked = false});
    propValue.checked = true;

    let checked = true;
    let size = '',color = '';
    for (let index = 0; index < this.state.saleProps.length; index++) {
      const prop = this.state.saleProps[index];
      const pvalue = prop.propsValues.find(x => x.checked == true);
      if(!pvalue){//未全部选中的情况
        checked = false;
        break;
      }
      if(index == 0)
        color = pvalue.value;
      else
        size = pvalue.value;
    }

    if(checked == false){
      this.setState({ })
      return;
    }
    const sku = this.state.selectProduct.Skus.find(x => x.Color == color && x.Size == size);
    
    // if(!sku || sku.AmountOnSale <= 0){
    //   propValue.checked = false;
    //   if(previousChecked) previousChecked.checked = true;
    // }
    
    if(!sku){
      messageShow('无此规格【' + color + ',' + size + '】','error')
      return;
    }
    if(sku.AmountOnSale <= 0){
      messageShow('规格【' + color + ',' + size + '】库存不足','error')
      // return;
    }
    
    this.setState({ })
  }
  saveSure = ()=>{
    const data = {}
    const propValues = [];
    for(const prop of this.state.saleProps){
      const propValue = prop.propsValues.find(x => x.checked == true)
      if(!propValue){
        messageShow('请选择【'+prop.label +'】','error')
        return
      }
      propValues.push(propValue)
    }
    if(propValues.length == 0){
      messageShow('请选择规格','error')
      return
    }
    const color = propValues[0].value
    const size = propValues.length > 1 ? propValues[1].value : ''
    const sku = this.state.selectProduct.Skus.find(x => x.Color == color && x.Size == size)
    console.log('sku =>',sku)
    if(!sku){
      messageShow('无此规格【' + color + ',' + size + '】','error')
      return
    }
    
    if(this.state.mappingCount <= 0){
      messageShow('数量必须大于1','error')
      return
    }
    sku.mappingCount = this.state.mappingCount
    
    this.props.saveSure(sku)
  }
  onChange= (name,value) =>{
    this.state[name] = value
    this.setState({})
  }
 
  render() {
    return (
      <ShowModal
        showLeftTopBtn={true}
        width={600}
        showModal={this.state.isShowDailog}
        titleName={this.state.title}
        skin={"singleCheckedSkuModule"}
        hideBtn={true}
        cancelDailog={this.closeShowModal} //取消按钮回调函数
      >
        <div className="showModalWrap-box-commonContent singleCheckedSkuModule-commonContent scroll-x">
          <div className='singleCheckedSkuModule-main'>
            <div>
              <div className='tarTxt03 tarTxt' style={{display: 'flex',padding:'5px 8px',marginBottom: '15px',marginTop: '-15px'}}>
                <span>注：只针对这笔订单，不保存关联关系，下次采购还是原货源规格</span>
              </div>
            </div>
            <div className='singleCheckedSkuModule-main-title'>
              <span>请选择您需要采购的货源规格数量</span>
            </div>
            <div className='singleCheckedSkuModule-main-content'>
              {
                this.state.saleProps.map(prop => 
                  <div className='singleCheckedSkuModule-main-content-item'>
                    <div className='singleCheckedSkuModule-main-content-title'><span>{prop.label}：</span></div>
                    <ul className='singleCheckedSkuModule-main-content-ul'>
                    {
                      prop.propsValues.map(propValue => 
                        propValue.checked == true ?
                        <li className='li-item defColor'>{propValue.label}</li>:
                        <li className='li-item' onClick={()=>{ this.selectPropValue(prop.propsValues,propValue)}}>{propValue.label}</li>
                      )
                    }
                    </ul>
                  </div>)
              }
              <div className='singleCheckedSkuModule-main-content-item'>
                  <div className='singleCheckedSkuModule-main-content-title'><span>数量：</span></div>
                  <div className='singleCheckedSkuModule-main-content-div'>
                    <input className='inputNumber' type="number" defaultValue={this.state.mappingCount} onChange={(e)=>{  this.onChange('mappingCount',e.target.value)} }/>
                  </div>
              </div>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span onClick={() => this.saveSure()} style={{ display: 'flex' }}
              className="showModalWrap-box-footer-btn">确定</span>
            <span onClick={() => this.closeShowModal()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
          </div>
        </div>
        
        <MyLoading isLoading={this.state.isLoading} title={this.state.loadingTitle} isStopOperate={true} fullCenter={true} />
      </ShowModal>
    );
  }



};

export default withRouter(SingleCheckSkuModule);



// WEBPACK FOOTER //
// ./src/components/singleCheckSkuModule/index.jsx